export default __webpack_public_path__ + "media/environment_friendly_banner.df8d26f4.png";